<template>
  <div v-html="getMenu()" class="hidden-xs-only" style="width: 100%"></div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  methods: {
    ...mapGetters("api_menu", ["getMenu"]),
    ...mapActions("api_menu", ["fetchMenu"]),
  },

  mounted() {
    if (this.$vuetify.breakpoint.mdAndUp) {
      const viewAs = localStorage.getItem("view_as") || "null";
      this.fetchMenu(viewAs).then(() => {
        this.$nextTick(() => {
          if (typeof initializeMenu === 'function') {
            initializeMenu();
          } else {
            console.error('La función initializeMenu no está disponible.');
          }
        });
      });
    }
  },

  watch: {
    getMenu() {
      this.$nextTick(() => {
        if (typeof initializeMenu === 'function') {
          initializeMenu();
        } else {
          console.error('La función initializeMenu no está disponible.');
        }
      });
    },
  },
  updated() {
    this.$nextTick(() => {
      if (typeof initializeMenu === 'function') {
        initializeMenu();
      } else {
        console.error('La función initializeMenu no está disponible.');
      }
    });
  },
};
</script>
